import getEnvEndpoints from "./endpoints";

const endpoints = getEnvEndpoints();

export const persistUser = data => {
  sessionStorage.setItem(endpoints.ls_name, JSON.stringify(data));
};

export const getUserData = () => {
  return JSON.parse(sessionStorage.getItem(endpoints.ls_name));
};

export const getUserId = () => {
    let userId = getUserData()?.id;
    return isNaN(userId) ? 0 : parseInt(userId);
};

export const clearUserData = () => {
  sessionStorage.removeItem(endpoints.ls_name);
  sessionStorage.clear();
};

export const getToken = () => {
    const userData = getUserData();

    if (userData) {
        return userData.access_token;
    }

    return null;
};

export const hasUserData = () => {
  return !!sessionStorage.getItem(endpoints.ls_name);
};

const SS_AUTH_ERROR = "splus.authError";
const TOKEN_EXPIRY_BUFFER_MS = 10 * 1000;

const decodeToken = (token) => {
  try {
    const payload = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(atob(payload));
  } catch (e) {
    return null;
  }
};

// Maps the OIDC access token claims to the user object the rest of the app expects
// (the same shape the pmi-login-iframe widget used to hand to window.onLogin).
export const mapTokenToUser = (token) => {
  const claims = decodeToken(token) || {};
  return {
    access_token: token,
    id: claims.person_id,
    person_id: claims.person_id,
    email: claims.email,
    given_name: claims.given_name,
    family_name: claims.family_name,
    sub: claims.sub,
    auth_time: claims.auth_time,
    exp_date: claims.exp ? new Date(claims.exp * 1000).toISOString() : undefined,
  };
};

export const updateUserToken = (token) => {
  const mapped = mapTokenToUser(token);
  const refreshedUser = Object.keys(mapped).reduce((acc, key) => {
    if (mapped[key] !== undefined) acc[key] = mapped[key];
    return acc;
  }, {});
  persistUser({ ...getUserData(), ...refreshedUser });
};

// Returns the token's expiry as epoch milliseconds, or null when it can't be read.
export const getTokenExpiry = (token) => {
  const decodedToken = token ? decodeToken(token) : null;
  return decodedToken && decodedToken.exp ? decodedToken.exp * 1000 : null;
};

export const isTokenExpired = (token = getToken()) => {
  const expiry = getTokenExpiry(token);
  return !expiry || expiry < Date.now() + TOKEN_EXPIRY_BUFFER_MS;
};

export const setAuthError = (message) => {
  sessionStorage.setItem(SS_AUTH_ERROR, message);
};

export const consumeAuthError = () => {
  const message = sessionStorage.getItem(SS_AUTH_ERROR);
  sessionStorage.removeItem(SS_AUTH_ERROR);
  return message;
};

export const setShareDeeplink = (shareDeeplink, shareDeeplinkPath) => {
  sessionStorage.setItem(shareDeeplink, shareDeeplinkPath);
};

export const getShareDeeplink = (shareDeeplink) => {
  return sessionStorage.getItem(shareDeeplink) || null;
};

export const clearShareDeeplink = (shareDeeplink) => {
  sessionStorage.removeItem(shareDeeplink);
};
